import { pb } from './pb';

export async function fetchChantiers(page = 1, perPage = 50, search = '') {
  const filters = [];
  if (search) {
    const s = search.replace(/"/g, '\\"');
    filters.push(`title ~ "%${s}%" || client_name ~ "%${s}%" || location ~ "%${s}%"`);
  }
  const filter = filters.join(' && ');
  return pb.collection('chantiers').getList(page, perPage, {
    filter,
    sort: '-created',
  });
}

export async function createChantier(data) {
  return pb.collection('chantiers').create(data);
}

export async function updateChantier(id, data) {
  return pb.collection('chantiers').update(id, data);
}

export async function deleteChantier(id) {
  return pb.collection('chantiers').delete(id);
}
